import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Unipile from "@/services/unipile/unipile";

/**
 * Composable for deleting WhatsApp messages using TanStack Query
 */
export function useDeleteWhatsAppMessage() {
  const queryClient = useQueryClient();

  const deleteMessageMutation = useMutation({
    mutationFn: async (messageId: string) => {
      const response = await Unipile.deleteMessage(messageId);
      return response.data;
    },
    onSuccess: () => {
      // Invalidate messages and conversations to refetch
      queryClient.invalidateQueries({
        queryKey: ["whatsapp-messages"],
      });
      queryClient.invalidateQueries({
        queryKey: ["whatsapp-conversations"],
      });
    },
  });

  return {
    deleteMessage: deleteMessageMutation.mutateAsync,
    isDeleting: deleteMessageMutation.isPending,
    deleteError: deleteMessageMutation.error,
  };
}
